import { Modal, TextButton, PrimaryButton, InputDate, Text } from "@artprov/design-system";
import { useModalConfirm } from "../hooks/useModalConfirm.js";
import PropTypes from "prop-types";

export default function ModalConfirm({ open, setOpen, selectedRows, onConfirm }) {
    const {
        // Estados del formulario
        fechaContableInput,
        customHint,

        // Handlers
        handleAccept,
        handleFechaContableChange,
        handleValidateFechaContable,
        handleCloseModal,

        // Validaciones
        isAcceptDisabled,
    } = useModalConfirm({ open, setOpen, selectedRows, onConfirm });

    return (
        <Modal.Container
            open={open}
            setOpen={setOpen}
            closeOnClickOutside={false}
            onClose={handleCloseModal}
        >
            <Modal.Content height="auto" width="540px">
                <Modal.Header className="mb-2">
                    <Modal.Title className="pl-2">Confirmar registros</Modal.Title>
                    <Modal.Close onClose={handleCloseModal} />
                </Modal.Header>

                <Modal.Body classNameScroll="!w-full" classNameScrollContainer="!overflow-visible">
                    <div className="flex flex-col space-y-4 w-full">
                        <Text variant="Body-M" className="text-left">
                            Se confirmará{selectedRows.length !== 1 ? 'n' : ''} {selectedRows.length} registro{selectedRows.length !== 1 ? 's' : ''}.
                            Por favor, ingresá la fecha contable.
                        </Text>

                        <InputDate
                            label="Fecha contable"
                            value={fechaContableInput}
                            onChange={handleFechaContableChange}
                            onValidate={handleValidateFechaContable}
                            hints={customHint ? [{ variant: 'error', text: customHint }] : []}
                        />
                    </div>
                </Modal.Body>

                <Modal.Footer className="flex justify-end">
                    <div className="flex">
                        <TextButton
                            className="mx-2"
                            size="small"
                            onClick={handleCloseModal}
                        >
                            Cancelar
                        </TextButton>
                        <PrimaryButton
                            className="mx-2"
                            size="small"
                            onClick={handleAccept}
                            classNameIcon="text-tertiary-100"
                            disabled={isAcceptDisabled}
                        >
                            Aceptar
                        </PrimaryButton>
                    </div>
                </Modal.Footer>
            </Modal.Content>
        </Modal.Container>
    );
}

ModalConfirm.propTypes = {
    open: PropTypes.bool.isRequired,
    setOpen: PropTypes.func.isRequired,
    selectedRows: PropTypes.array.isRequired,
    onConfirm: PropTypes.func.isRequired,
};
